import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ZipYiService } from '~services';
import { ZipYiContext } from '~services/biocatch/zip-yi-context.enum';

@Component({
  selector: 'app-error-view',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss', '../../../scss/error.styling.scss'],
})
export class ErrorViewComponent implements OnInit {
  appPrefix = environment.appPrefix;
  status = this.ngActivatedRoute.snapshot.params.status || "Uh oh, something's not right.";
  error = this.ngActivatedRoute.snapshot.params.description;

  constructor(
    private ngActivatedRoute: ActivatedRoute,
    private ngRouter: Router,
    private zipYiService: ZipYiService,
  ) {}

  ngOnInit(): void {
    this.zipYiService.setContext(ZipYiContext.GeneralErrorPage);
    window.zbm?.markAsErrorPage(500, `${this.status} - ${this.error}`);
  }

  goToHome() {
    this.ngRouter.navigate(['au/giftcards']);
  }
}
